// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .button-container {
        display: flex;
        justify-content: space-between;
      }
    `, "",{"version":3,"sources":["webpack://./projects/ert/src/app/ert-firedepartment-bc-turnover/ert-firedepartment-bc-turnover-create.component.ts"],"names":[],"mappings":";MACM;QACE,aAAa;QACb,8BAA8B;MAChC","sourcesContent":["\n      .button-container {\n        display: flex;\n        justify-content: space-between;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
